export enum FontHeightToken {
  micro = '1.8rem',
  small = '2rem',
  medium = '2.4rem',
  large = '2.8rem',
  xLarge = '3rem',
  xXLarge = '3.2rem',
  huge = '3.8rem',
  xHuge = '4.4rem',
  xXHuge = '6rem',
  giant = '7.2rem',
  display = '9rem',
}

export default FontHeightToken

export type TLineHeight =
  | 'micro'
  | 'small'
  | 'medium'
  | 'large'
  | 'xLarge'
  | 'xXLarge'
  | 'huge'
  | 'xHuge'
  | 'xXHuge'
  | 'giant'
  | 'display'
